const getFeatureFlags = () => {
    return {
        isChatEnabled: false
    };
};
export default getFeatureFlags;
